export const GET_ALL_PACKAGES_SUCCESS = "logistics/GET_ALL_PACKAGES_SUCCESS";
export const GET_ALL_PACKAGES_FAILURE = "logistics/GET_ALL_PACKAGES_FAILURE";
export const GET_ALL_TRANSPORT_SUCCESS = "logistics/GET_ALL_TRANSPORT_SUCCESS";
export const GET_ALL_TRANSPORT_FAILURE = "logistics/GET_ALL_TRANSPORT_FAILURE";

